import React from "react";
import { appColors, appRadius, appShadows, appType } from "../../utils/appTheme";
import IconBox from "./IconBox";

/**
 * Tile de acceso. layout: "grid" (vertical, para grillas 2×2) | "row" (horizontal).
 * badge: número de notificación (círculo azul sobre la esquina del icono).
 */
const Tile = ({
  icon,
  name,
  subtitle,
  meta,
  metaColor = appColors.ink2,
  badge,
  layout = "grid",
  onClick,
  style,
}) => {
  const isRow = layout === "row";

  const iconWithBadge = (
    <span style={{ position: "relative", display: "inline-flex" }}>
      <IconBox icon={icon} />
      {badge != null && badge !== 0 && (
        <span
          style={{
            position: "absolute",
            top: -5,
            right: -5,
            minWidth: 17,
            height: 17,
            padding: "0 4px",
            borderRadius: 999,
            background: appColors.blue,
            color: appColors.onBlue,
            border: `2px solid ${appColors.surface}`,
            fontSize: 10,
            fontWeight: 400,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
        >
          {badge}
        </span>
      )}
    </span>
  );

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: "flex",
        flexDirection: isRow ? "row" : "column",
        alignItems: isRow ? "center" : "flex-start",
        gap: isRow ? 12 : 10,
        minHeight: isRow ? undefined : 120,
        width: "100%",
        textAlign: "left",
        background: appColors.surface,
        border: `1px solid ${appColors.line2}`,
        borderRadius: appRadius.tile,
        boxShadow: appShadows.soft,
        padding: 16,
        cursor: "pointer",
        ...style,
      }}
    >
      {iconWithBadge}
      <span style={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
        <span style={{ ...appType.tileName }}>{name}</span>
        {subtitle && <span style={{ ...appType.bodySm }}>{subtitle}</span>}
        {meta && (
          <span style={{ ...appType.bodySm, color: metaColor, marginTop: 2 }}>
            {meta}
          </span>
        )}
      </span>
    </button>
  );
};

export default Tile;
